import moment from "moment";
import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_TABLE_CHART_SUCCESS,
  FETCH_LINE_CHART_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  UPDATE_CROSS_REGIONAL_VISITS_SELECTED,
  UPDATE_CUSTOM_RANGE,
  UPDATE_PERIOD_TYPE,
  UPDATE_DATES,
  SET_CROSS_REGIONAL_VISITS,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_DATES,
  RESET_FILTER_SELECTED
} from "./activeClientsSagas";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../../utils/date-range-options";

export const initialState = {
  currentUser: {},
  initialRequest: false,
  chartData: {},
  tableChartData: {},
  isLoading: true,
  updatesLoading: false,
  filtersDirty: false,
  selectedRequestDates: {},
  filters: {
    period_type: "monthly",
    toggles: {
      crossRegionalVisits: {},
      compareDates: {}
    }
  },
  selectedFilters: {
    period_type: "Monthly",
    include_cross_regional_visits: false
  },
  periodTypeOptions: ["Daily", "Monthly"],
  selectedRangeOption: {},
  rangeOptions: []
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => {
      const rangeOptions = getRangeOptions(
        action.payload.endDate,
        state.currentUser.calendarStartDate
      );
      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [SET_CROSS_REGIONAL_VISITS]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        include_cross_regional_visits: action.payload
      }
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload,
      filtersDirty: true,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action)
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload || state.filters
    }),
    [FETCH_LINE_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload
    }),
    [FETCH_TABLE_CHART_SUCCESS]: (state, action) => ({
      ...state,
      tableChartData: action.payload
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: { ...initialState.selectedFilters }
    }),
    [UPDATE_CROSS_REGIONAL_VISITS_SELECTED]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        include_cross_regional_visits: action.payload
      }
    }),
    [UPDATE_PERIOD_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      ...getDatesForCustomRange({
        periodType: action.payload,
        selectedRangeOption: state.selectedRangeOption,
        rangeOptions: state.rangeOptions,
        calendarEndDate: state.currentUser.calendarEndDate
      }),
      selectedFilters: {
        ...state.selectedFilters,
        period_type: action.payload
      }
    })
  },
  initialState
);

const getDatesForCustomRange = ({
  periodType,
  selectedRangeOption: { name, startDate, endDate },
  calendarEndDate,
  rangeOptions
}) => {
  if (periodType === "Monthly" && name.includes("Custom Range")) {
    const format = "YYYY-MM-DD";

    let newStartDate = moment(startDate).startOf("month").format(format);
    let newEndDate =
      moment(endDate).month() === moment(calendarEndDate).month()
        ? calendarEndDate
        : moment(endDate).endOf("month").format(format);

    let payload = {
      startDate: newStartDate,
      endDate: newEndDate
    };
    return {
      selectedRequestDates: payload,
      rangeOptions: getRangeOptionsWithCustom(rangeOptions, { payload }),
      selectedRangeOption: getSelectedRangeOptionWithCustom({ payload }),
      startDate: newStartDate,
      endDate: newEndDate
    };
  }
  return {};
};
